import React, { useState, useEffect } from "react";

const YearDropdown = ({ selectedYear, setSelectedYear }) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 3 }, (_, i) => currentYear - 2 + i);

  return (
    <div className="card shadow-sm rounded border-primary border-2 p-3">
      <div className="col-md-full">
        <select
          className="form-select bg-light text-dark text-center mobile-font"
          value={selectedYear}
          onChange={(e) => setSelectedYear(Number(e.target.value))}
        >
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};


export default YearDropdown;
